<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Profile",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Profile",
            items: [                         
               
               {
                  text: "Profile",
                  active: true,
               },                     
            ],

            hub: {},
            contacts: null,
            leads: null,
            businesses: null,
            token: '',

            loading: false,

         };
      },
      mounted() {
    
      },

      created() {
        
         this.fetchHub();
      },

      methods: {
         getToken() {
            if (localStorage.getItem('vc_hub')) {
               var vc_hub =  JSON.parse(localStorage.getItem('vc_hub'));
               if(vc_hub.token) {
                  this.token = vc_hub.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },      

         
         fetchHub() {
            let url = "/api/hub/profile";         
            this.getToken();
            this.loading = true;
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  //console.log(responseData);
                  this.hub = responseData.profile;  
                  this.contacts = responseData.contacts;
                  this.leads = responseData.leads;
                  this.businesses = responseData.businesses;                
               })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
              
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />

      <div class="row">
         <div class="col-xl-6 col-lg-6">
            <div class="card overflow-hidden hub-profile">
               <div class="bg-soft bg-primary">
                  <div class="row">
                     <div class="col-7">
                        <div class="text-primary p-3">
                           <h5 class="text-primary">{{hub.business_name}}</h5>
                           <h6>UID: {{hub.uid}}</h6>

                        </div>
                     </div>
                     <div class="col-5 align-self-end">
                        <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
                     </div>
                  </div>
               </div>
               <div class="card-body pt-0">
                  <div class="row">
                     <div class="col-sm-5 col-xl-4">
                        <div class="avatar-md profile-user-wid mb-2">
                           <img v-if="hub.business_logo" :src="$image_url + hub.business_logo" alt="Hub Logo" class="img-thumbnail rounded-circle" />
                           <img v-else src="@/assets/images/no-image.png" alt="No Image" class="img-thumbnail rounded-circle" />
                        </div>
                        <div class="mt-3">
                           <a href="/profile/edit" class="btn btn-primary btn-sm">
                                 Edit Profile
                                 <i class="mdi mdi-arrow-right ms-1"></i>
                           </a>
                           
                        </div>    
                     </div>

                     <div class="col-sm-7 col-xl-8 pt-2">
                        <div class="d-flex align-items-center mb-3">
                           <div class="avatar-xs me-1">
                              <span class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-14"><i class="bx bx-phone"></i></span>
                           </div>
                           <h5 class="font-size-14 mb-0">+91 {{hub.bus_mobile}}</h5>
                        </div>

                        <div class="d-flex align-items-center mb-3">
                           <div class="avatar-xs me-1">
                              <span class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-14"><i class="bx bx-envelope"></i></span>
                           </div>
                           <h5 class="font-size-14 mb-0">{{hub.business_email}}</h5>
                        </div>        
                     </div>

                     <div class="col-12">
                        
                     </div>
                  </div>

                  <div class="row mt-3">
                     <div class="col-4">
                        <h5 class="font-size-15">{{contacts}}</h5>
                        <p class="text-muted mb-0">Contacts</p>
                     </div>
                     <div class="col-4">
                        <h5 class="font-size-15">{{leads}}</h5>
                        <p class="text-muted mb-0">Leads</p>
                     </div>
                     <div class="col-4">
                        <h5 class="font-size-15">{{businesses}}</h5>
                        <p class="text-muted mb-0">Businesses</p>
                     </div>
                  </div>


               </div>
            </div>
            <!-- end card -->

            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-4 ps-2">Client Details</h4>

                  <div class="table-responsive">
                     <table class="table mb-0">
                        <tbody>
                           <tr>
                              <th>Name  </th>
                              <th>:</th>
                              <td>{{hub.client_name}}</td>
                           </tr>
                                 
                           <tr>
                              <th>Mobile </th>
                              <th>:</th>
                              <td>+91 {{hub.cli_mobile}}</td>
                           </tr>

                           <tr>
                              <th>Secondary Mobile </th>
                              <th>:</th>
                              <td v-if="hub.client_secondary_number">{{hub.client_secondary_number}}</td>
                              <td v-else>-</td>
                           </tr>

                           <tr>
                              <th>Email </th>
                              <th>:</th>
                              <td>{{hub.client_email}}</td>
                           </tr>

                           <tr>
                              <th>Address </th>
                              <th>:</th>
                              <td>{{hub.client_address}}</td>
                           </tr>

                           <tr>
                              <th>Place </th>
                              <th>:</th>
                              <td>{{hub.place}}</td>
                           </tr>

                           <tr>
                              <th>City </th>
                              <th>:</th>
                              <td>{{hub.city}}</td>
                           </tr>

                           <tr>
                              <th>District </th>
                              <th>:</th>
                              <td>{{hub.client_district}}</td>
                           </tr>

                           <tr>
                              <th>State </th>
                              <th>:</th>
                              <td>{{hub.client_state}}</td>
                           </tr>

                           <tr>
                              <th>Pincode </th>
                              <th>:</th>
                              <td>{{hub.pincode}}</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
               </div>
            </div>
            <!-- end card -->
         </div>
         <div class="col-xl-6 col-lg-6">
            <div class="card">
               <div class="card-body">
                  <div class="clearfix">                     
                     <h4 class="card-title mb-3 ps-2" style="line-height: 35px;">Business Details</h4>
                  </div>
                  <div class="row">
                     <div class="col-12">
                        <div class="table-responsive">
                           <table class="table mb-0">
                              <tbody>
                                 
                                 <tr>
                                    <th>Business Type </th>
                                    <th>:</th>
                                    <td>{{hub.type}}</td>
                                 </tr>                                 

                                 <tr>
                                    <th>Business Age </th>
                                    <th>:</th>
                                    <td>{{hub.business_age}} years</td>
                                 </tr>

                                 <tr>
                                    <th>Address </th>
                                    <th>:</th>
                                    <td>{{hub.business_address}}</td>
                                 </tr>

                                 <tr>
                                    <th>Place </th>
                                    <th>:</th>
                                    <td>{{hub.business_place}}</td>
                                 </tr>

                                 <tr>
                                    <th>City </th>
                                    <th>:</th>
                                    <td>{{hub.business_city}}</td>
                                 </tr>

                                 <tr>
                                    <th>District </th>
                                    <th>:</th>
                                    <td>{{hub.business_district}}</td>
                                 </tr>

                                 <tr>
                                    <th>State </th>
                                    <th>:</th>
                                    <td>{{hub.business_state}}</td>
                                 </tr>

                                 <tr>
                                    <th>Pincode </th>
                                    <th>:</th>
                                    <td>{{hub.business_pincode}}</td>
                                 </tr>

                                 <tr>
                                    <th>Ownership </th>
                                    <th>:</th>
                                    <td>{{hub.ownership}}</td>
                                 </tr>

                                 <tr>
                                    <th>Subscription Expires on</th>
                                    <th>:</th>
                                    <td>{{hub.subscription_ends}}</td>
                                 </tr>

                                 <tr>
                                    <th>Mobile </th>
                                    <th>:</th>
                                    <td>+91 {{hub.bus_mobile}}</td>
                                 </tr>                                 

                                 <tr>
                                    <th>Email </th>
                                    <th>:</th>
                                    <td>{{hub.business_email}}</td>
                                 </tr>
                             
                              </tbody>
                           </table>
                        </div>
                     </div>
                  </div>
               </div>
            </div> 
         </div>
      </div>
      <!-- end row -->

   </Layout>
</template>
